import { Button } from "@/components/ui/button";
import { usePaginationInput } from "@/hooks/dashboard/usePaginationInput";
import type { TSessionsResponse } from "@/types/TSessionsResponse";
import { useTranslation } from "react-i18next";

interface SessionsPaginationProps {
  sessionsResponse: TSessionsResponse;
  onPreviousPage: () => void;
  onNextPage: () => void;
  onPageChange: (page: number) => void;
}

export function SessionsPagination({
  sessionsResponse,
  onPreviousPage,
  onNextPage,
  onPageChange
}: SessionsPaginationProps) {
  const { t } = useTranslation();
  const totalPages = Math.ceil(sessionsResponse.total / sessionsResponse.page_size);
  const actualCorrectedPageIndex = sessionsResponse.page;

  const {
    pageInput,
    handleInputChange,
    handleKeyDown,
    handleInputBlur,
  } = usePaginationInput({
    currentPage: actualCorrectedPageIndex,
    totalPages,
    onPageChange,
  });
  return (
    <div className="flex justify-between items-center">
      <div className="flex items-center gap-2">
        <Button
          variant="outline"
          onClick={onPreviousPage}
          disabled={actualCorrectedPageIndex <= 1}
        >
          {t("sessions.previous")}
        </Button>

        <div className="flex items-center">
          <div className="text-sm flex items-center">
            {t("sessions.page")}
            <input
              type="text"
              value={pageInput}
              onChange={handleInputChange}
              onKeyDown={handleKeyDown}
              onBlur={handleInputBlur}
              className="border border-gray-300 rounded-md px-2 py-1 w-12 mx-2 text-center"
              aria-label={t("sessions.goToPage")}
            />
            {t("sessions.of")} {totalPages}
          </div>
        </div>

        <Button
          variant="outline"
          onClick={onNextPage}
          disabled={actualCorrectedPageIndex >= totalPages}
        >
          {t("sessions.next")}
        </Button>
      </div>
      <div className="text-sm text-gray-500">
        {t("sessions.showing", { count: sessionsResponse.data.length, total: sessionsResponse.total })}
      </div>
    </div>
  );
}